'use client';

import RecentlyViewedSlider from 'components/commercetools-ui/organisms/recentlyViewedProduct';
import React from 'react';
import { Product } from 'shared/types/product';
import { TasticProps } from '../types';

type Data = {
  data: {
    dataSource: {
      items: Product[];
    };
  };
};
const RecentlyViewedTastic = ({ data }: TasticProps<Data>) => {
  const recentlyViewed = data?.data?.dataSource?.items;
  return (
    <>
      <RecentlyViewedSlider productFromCategory={recentlyViewed} />
    </>
  );
};

export default RecentlyViewedTastic;
